module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.items && _vm.items.length > 0) ? _c('div', {
    staticClass: "search-qls"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "search-ql-container"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "search-ql"
    }, [_c('a', {
      attrs: {
        "href": item.link
      }
    }, [_vm._v(_vm._s(item.label))])])
  }))]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-ql-header"
  }, [_c('h3', [_vm._v("Quick Links")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eeb4f66","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=pnre6zws23l!./~/string-replace-webpack-plugin/loader.js?id=hfo8n7cvtpt!./src/components/search/SearchQuickLink.vue
// module id = 681
// module chunks = 0